import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import Hero from './Hero';
import SectionLoans from './SectionLoans';
import SectionHowItWorks from './SectionHowItWorks';
import SectionDebt from './SectionDebt';
import SectionExample from './SectionExample';
import '../../assets/css/custom.css';
import '../../assets/css/responsive.css';

class Index extends Component {
    render() {
        return (
            <div className="site_main">
                <Header />
                <Hero />
                <SectionLoans />
                <SectionHowItWorks />
                <SectionDebt />
                <SectionExample />
                <Footer />
            </div>
        )
    }
}
export default Index


// WEBPACK FOOTER //
// ./src/components/Landing/Index.js